module.exports = __webpack_public_path__ + "static/img/idea_mid.f44e4b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newWebSiteImg/pc/home/idea_mid.png
// module id = 0FGe
// module chunks = 3